import styled from '@emotion/styled';
import { DeprecatedInlineMessage, SkeletonPlaceholder } from '@modernhealth/vital-components';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useWellbeingReportMonitoringMessageQuery } from 'src/modules/assessments/documents/getWellbeingReportMonitoringMessageQuery.generated';

export enum Encouragement {
    ENCOURAGE_ASSESSMENT_RETAKE_MESSAGE = 'encourage_assessment_retake_message',
}

export const WellbeingReportMonitoringMessage: React.FC = () => {
    const { data, loading, refetch } = useWellbeingReportMonitoringMessageQuery({
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: false,
    });

    const messageType = data?.wellbeingReportMonitoringMessage?.messageType;

    useEffect(() => {
        refetch();
    }, [messageType, refetch]);

    const { t } = useTranslation();

    if (loading) {
        return <SkeletonPlaceholder marginTop={20} width="100%" height={40} />;
    }

    if (!messageType) return null;

    const message = Encouragement[messageType];

    return (
        <Wrapper>
            <DeprecatedInlineMessage message={t(`assessments:wellbeing_report.${message}`)} />
        </Wrapper>
    );
};

const Wrapper = styled.div({
    marginTop: '20px',
});
